:host {
  display: block;
}

.textlink {
  display: inline-block;
  box-sizing: border-box;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-family: var(--copytext-font-family);
  font-weight: 700;
  line-height: 1.1;
  letter-spacing: var(--letter-spacing-basic);
  margin: 0;
  padding: 0;

  &.uppercase {
    text-transform: uppercase;
  }

  &.bold {
    @apply font-text-bold;
  }
  &.disabled {
    @apply pointer-events-none;
  }
  &.big {
    font-size: var(--textlink-text-size-default);
  }
  &.small {
    font-size: var(--textlink-text-size-small);
  }

  & .textlink-content-wrapper-icon-and-label {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  & .textlink-content-wrapper-icon {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  & .textlink-icon-padding-right {
    padding-right: 8px;
  }

  & .textlink-icon-padding-left {
    padding-left: 8px;
  }

  &:hover {
    cursor: pointer;
  }

  &.light {
    & a {
      color: var(--color-steel-800);
      text-decoration: none;
    }

    & .icon * {
      color: var(--color-steel-800) !important;
    }

    & .textlink-content-wrapper-label {
      padding-bottom: 4px;
      border-bottom: 2px solid;
      border-color: var(--color-steel-800);
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }

    &:hover a {
      color: var(--color-steel-600);
    }

    &:hover .textlink-content-wrapper-label {
      border-color: var(--color-steel-600);
    }

    &:hover .icon * {
      color: var(--color-steel-600) !important;
    }

    &.disabled a {
      @apply text-gray-400;
    }

    &.disabled .textlink-content-wrapper-label {
      @apply border-gray-400;
    }

    &.disabled .icon * {
      color: var(--color-steel-400) !important;
    }

    &:active a {
      color: var(--color-black);
    }

    &:active .textlink-content-wrapper-label {
      border-color: var(--color-black);
    }

    &:active .icon * {
      color: var(--color-black) !important;
    }
  }

  &.dark {
    & a {
      color: var(--color-white);
      text-decoration: none;
    }

    & .icon * {
      color: var(--color-white) !important;
    }

    & .textlink-content-wrapper-label {
      padding-bottom: 4px;
      border-bottom: 2px solid;
      border-color: var(--color-white);
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }

    &:hover a {
      color: var(--color-steel-600);
    }

    &:hover .textlink-content-wrapper-label {
      border-color: var(--color-steel-600);
    }

    &:hover .icon * {
      color: var(--color-steel-600) !important;
    }

    &.disabled a {
      @apply text-gray-500;
    }

    &.disabled .textlink-content-wrapper-label {
      @apply border-gray-500;
    }

    &.disabled .icon * {
      color: var(--color-steel-500) !important;
    }

    &:active a {
      color: var(--color-white);
    }

    &:active .textlink-content-wrapper-label {
      border-color: var(--color-white);
    }

    &:active .icon * {
      color: var(--color-white) !important;
    }
  }
}
